<template>
  <div class="platform-homework" v-loading="loading">
    <div
      class="platform-homework-header"
      v-if="resDatas.length !== 3 && !loading"
    >
      项目做完啦？快来提交吧，提交后，老师将会对你提交的项目审阅指导。一共还有
      {{ 3 - resDatas.length }} 次提交机会。
      <el-button
        v-if="homework.status !== 1 && homework.homework_status !== 1"
        type="primary"
        plain
        class="submit-again"
        size="small"
        @click="handleSubmitAgain"
        >再次提交</el-button
      >
    </div>

    <!-- 提交作业表单 -->
    <div class="platform-homework-form" v-if="showForm">
      <div class="homework-form-title">
        请将项目作品打包上传，老师会进行仔细审阅，给出文字和视频反馈
      </div>
      <el-form
        :model="formData"
        :rules="formRules"
        ref="homeworkForm"
        label-position="right"
        label-width="210px"
      >
        <el-form-item label="项目完成效果自我评价" prop="self_evaluation">
          <el-select
            v-model="formData.self_evaluation"
            placeholder="请选择评价"
          >
            <el-option
              v-for="item in homeworkOpt"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自我总结" prop="self_summary">
          <el-input
            v-model="formData.self_summary"
            type="textarea"
            :rows="4"
            :placeholder="
              `项目做完了，自我总结一下，比如\n1、在项目中学到了哪些东西？\n2、在做项目时有哪些疑惑，如何解决的？\n3、项目完成后的感受是什么？`
            "
          />
        </el-form-item>
        <el-form-item label="项目编码花费总时间" prop="spend_time">
          <el-input
            v-model="formData.spend_time"
            type="number"
            style="width: 200px;"
          >
            <template slot="append"
              >小时</template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="file_id">
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :limit="1"
            :file-list="fileList"
            :before-upload="handleBeforeUpload"
            :on-preview="handleOnPreview"
            :on-remove="handleBeforeRemove"
            accept="aplication/zip, application/x-zip-compressed, application/octet-stream"
          >
            <el-button
              slot="trigger"
              :loading="btnloading"
              plain
              size="small"
              type="primary"
              >选取文件</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传 zip，rar 格式文件，且不超过20MB
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="有哪些想对审阅老师说" prop="speak_to_teacher">
          <el-input
            v-model="formData.speak_to_teacher"
            type="textarea"
            :rows="4"
            :placeholder="
              `有什么想跟审阅老师说的，比如\n1.项目完成度和运行状态的自我评估\n2.特别想请审阅老师注意的地方\n等等`
            "
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 作业预览 -->
    <div class="platform-homework-preview" v-if="showPreview">
      <!-- 老师评审结果 -->
      <div class="homework-preview-teacher" v-if="showTeacherPreview">
        <div class="homework-preview-header">
          <div class="homework-preview-title">老师对项目作品的审阅</div>
          <div class="homework-preview-score">{{ homework.level }}</div>
          <div class="homework-preview-header-info">
            <div class="header-info-item">
              审阅时间：
              {{ homework.evaluate_at ? formatTime(homework.evaluate_at) : "" }}
            </div>
            <div class="header-info-item">审阅老师：{{ teacher.name }}</div>
            <div class="header-info-item" v-if="homework.evaluate_file">
              <a download :href="homework.evaluate_file.path" target="_blank"
                >审阅视频讲解 <i class="el-icon-link download__icon"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="homework-preview-body">
          <div class="home-preview-body-info">
            <div class="body-info-item">
              <div class="body-info-label">老师评语：</div>
              <markdown-it :md="homework.teacher_comment"></markdown-it>
            </div>
          </div>
          <div class="homework-preview-slider">
            <div class="preview-slider-item">
              <div class="slider-item-label">结果</div>
              <div class="slider-item-content">
                <div class="item-slider-bg">
                  <span
                    class="item-slider-bg-mask"
                    :style="{
                      width: (1 - level_detail.result / 20) * 100 + '%'
                    }"
                  ></span>
                </div>
                <div class="item-slider-option-list">
                  <div class="item-slider-option">0</div>
                  <div class="item-slider-option">5</div>
                  <div class="item-slider-option">10</div>
                  <div class="item-slider-option">15</div>
                  <div class="item-slider-option">20</div>
                </div>
                <span
                  class="item-slider-tooltip"
                  :style="{ left: (level_detail.result / 20) * 100 + '%' }"
                >
                  {{ level_detail.result }} 分</span
                >
              </div>
            </div>
            <div class="preview-slider-item">
              <div class="slider-item-label">稳定性</div>
              <div class="slider-item-content">
                <div class="item-slider-bg">
                  <span
                    class="item-slider-bg-mask"
                    :style="{
                      width: (1 - level_detail.stability / 20) * 100 + '%'
                    }"
                  ></span>
                </div>
                <div class="item-slider-option-list">
                  <div class="item-slider-option">0</div>
                  <div class="item-slider-option">5</div>
                  <div class="item-slider-option">10</div>
                  <div class="item-slider-option">15</div>
                  <div class="item-slider-option">20</div>
                </div>
                <span
                  class="item-slider-tooltip"
                  :style="{ left: (level_detail.stability / 20) * 100 + '%' }"
                >
                  {{ level_detail.stability }} 分</span
                >
              </div>
            </div>
            <div class="preview-slider-item">
              <div class="slider-item-label">思路</div>
              <div class="slider-item-content">
                <div class="item-slider-bg">
                  <span
                    class="item-slider-bg-mask"
                    :style="{
                      width: (1 - level_detail.thinking / 20) * 100 + '%'
                    }"
                  ></span>
                </div>
                <div class="item-slider-option-list">
                  <div class="item-slider-option">0</div>
                  <div class="item-slider-option">5</div>
                  <div class="item-slider-option">10</div>
                  <div class="item-slider-option">15</div>
                  <div class="item-slider-option">20</div>
                </div>
                <span
                  class="item-slider-tooltip"
                  :style="{ left: (level_detail.thinking / 20) * 100 + '%' }"
                >
                  {{ level_detail.thinking }} 分</span
                >
              </div>
            </div>
            <div class="preview-slider-item">
              <div class="slider-item-label">结构及逻辑</div>
              <div class="slider-item-content">
                <div class="item-slider-bg">
                  <span
                    class="item-slider-bg-mask"
                    :style="{
                      width: (1 - level_detail.logic / 20) * 100 + '%'
                    }"
                  ></span>
                </div>
                <div class="item-slider-option-list">
                  <div class="item-slider-option">0</div>
                  <div class="item-slider-option">5</div>
                  <div class="item-slider-option">10</div>
                  <div class="item-slider-option">15</div>
                  <div class="item-slider-option">20</div>
                </div>
                <span
                  class="item-slider-tooltip"
                  :style="{ left: (level_detail.logic / 20) * 100 + '%' }"
                >
                  {{ level_detail.logic }} 分</span
                >
              </div>
            </div>
            <div class="preview-slider-item">
              <div class="slider-item-label">代码规范性</div>
              <div class="slider-item-content">
                <div class="item-slider-bg">
                  <span
                    class="item-slider-bg-mask"
                    :style="{
                      width: (1 - level_detail.normalization / 20) * 100 + '%'
                    }"
                  ></span>
                </div>
                <div class="item-slider-option-list">
                  <div class="item-slider-option">0</div>
                  <div class="item-slider-option">5</div>
                  <div class="item-slider-option">10</div>
                  <div class="item-slider-option">15</div>
                  <div class="item-slider-option">20</div>
                </div>
                <span
                  class="item-slider-tooltip"
                  :style="{
                    left: (level_detail.normalization / 20) * 100 + '%'
                  }"
                >
                  {{ level_detail.normalization }} 分</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 批改评价 -->
      <div
        class="platform-homework-comment"
        v-if="homework.homework_status === 3"
      >
        <!-- 未评价 -->
        <div v-if="!homework.student_evaluate_feedback">
          <div class="platform-comment-title">本次老师点评满意吗？</div>
          <div class="platform-comment-list">
            <div
              class="platform-comment-item"
              v-for="item in commitOpt"
              :key="item.value"
            >
              <!-- <img class="platform-comment-icon"/> -->
              <!-- <span class="platform-comment-text">满意</span> -->
              <span class="platform-comment-btn" @click="handleComment(item)">{{
                item.name
              }}</span>
            </div>
          </div>
        </div>
        <!-- 已经评价 -->
        <div v-if="homework.student_evaluate_feedback">
          <div class="platform-comment-title">对本次点评的评价</div>
          <span class="platform-comment-text">
            {{ commitOpt[homework.student_evaluate_feedback - 1].name }}
          </span>
        </div>
      </div>

      <!-- 学生作业预览 -->
      <div class="platform-homework-header" v-if="showStudentPreview">
        <span v-if="homework.homework_status === 1"
          >老师会在 24 小时内完成审阅</span
        >
        <span class="platform-homework-header-text">
          {{ homework.created_at ? formatTime(homework.created_at) : "" }} 提交
        </span>
      </div>
      <div class="homework-preview-student">
        <div class="homework-preview-header">
          <div class="homework-preview-title">我提交的项目作品</div>
          <span
            class="homework-preview-revert"
            @click="hanleDeleteHomeworks"
            v-if="homework.homework_status === 1"
            >撤销</span
          >
          <div class="homework-preview-header-info">
            <div class="header-info-item">
              自我评价： {{ selfEvaluationDisplay }}
            </div>
            <div class="header-info-item">
              项目编码耗时：{{ homework.spend_time }} 小时
            </div>
            <div class="header-info-item">
              <a
                download
                :href="homework.file ? homework.file.path : ''"
                target="_blank"
                >提交的项目源码<i class="el-icon-link download__icon"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="homework-preview-body">
          <div class="home-preview-body-info">
            <div class="body-info-item">
              <div class="body-info-label">自我总结：</div>
              <div class="body-info-content">{{ homework.self_summary }}</div>
            </div>
            <div class="body-info-item">
              <div class="body-info-label">想对审阅老师说的话：</div>
              <div class="body-info-content">
                {{ homework.speak_to_teacher }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import plusService from "@/global/services/jikerPlus";
import qiniuService from "@/global/services/qiniuPlus";
import formatDate from "@/global/utils/date";

const homeworkOpt = [
  { name: "A - 优秀", id: 1 },
  { name: "B - 良好", id: 2 },
  { name: "C - 一般", id: 3 },
  { name: "D - 及格", id: 4 },
  { name: "E - 不及格", id: 5 }
];

const commitOpt = [
  { name: "非常满意", id: 1 },
  { name: "满意", id: 2 },
  { name: "基本满意", id: 3 },
  { name: "不满意", id: 4 },
  { name: "非常不满意", id: 5 }
];

export default {
  components: {
    MarkdownIt
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    sourceId: {
      type: [Number, String],
      required: true
    },
    projectId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      loading: true,
      showHeader: false,
      showForm: false,
      showTeacherPreview: false,
      showStudentPreview: false,
      showComment: false,
      resDatas: [],
      homework: {},
      teacher: {},
      level_detail: {
        logic: 0,
        normalization: 0,
        result: 0,
        stability: 0,
        thinking: 0
      },
      btnloading: false,
      uploadLimit: 20,
      homeworkOpt,
      commitOpt,
      formData: {
        self_evaluation: "",
        self_summary: "",
        spend_time: "",
        file: null,
        file_id: "",
        speak_to_teacher: ""
      },
      formRules: {
        self_evaluation: { required: true, message: "请选择自我评价" },
        self_summary: { required: true, message: "请输入自我总结" },
        spend_time: { required: true, message: "请输入正确项目编码花费总时间" },
        file_id: { required: true, message: "请上传项目文件" }
      },
      fileList: []
    };
  },
  computed: {
    showPreview() {
      return this.showTeacherPreview || this.showStudentPreview;
    },
    selfEvaluationDisplay() {
      let selfEvaluation = this.homework.self_evaluation;
      if (selfEvaluation) {
        let selfEvaluationValue = this.homeworkOpt.find(
          data => data.id === selfEvaluation
        );
        return selfEvaluationValue.name;
      } else {
        return "";
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    formatTime(date) {
      const data = new Date(date);
      return formatDate.formatTime(data);
    },
    getData() {
      this.loading = true;
      plusService
        .getHomeworks({
          source: "kongfu",
          source_id: this.sourceId,
          project_id: this.projectId,
          project_content_id: this.id
        })
        .then(res => {
          this.resDatas = res;
          if (!res.length) {
            this.showHeader = true;
            this.showForm = true;
          } else {
            const homework = res[0];
            this.setHomework(homework);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setHomework(data) {
      this.homework = data;
      if (data.homework_status === 1) {
        this.showStudentPreview = true;
      } else {
        this.showStudentPreview = true;
        this.showTeacherPreview = true;
        this.teacher = data.teacher;
        this.level_detail = data.level_detail;
      }
    },
    handleSubmitAgain() {
      this.showForm = true;
      this.showTeacherPreview = false;
      this.showStudentPreview = false;
      this.homework.status = 0;
    },
    handleOnPreview(file) {
      window.open(file.url);
    },
    handleBeforeRemove(file) {
      if (file && file.status === "success") {
        this.fileList = [];
        this.formData.file_id = "";
      }
    },
    handleBeforeUpload(file) {
      if (!file || !this.validateSize(file)) {
        return false;
      }
      const space = "_for_plus_sub_project";
      const folder = "ying";
      this.btnloading = true;
      qiniuService
        .upload({ space, folder, file }, () => {})
        .then(res => {
          this.fileList = [{ name: res.name, url: res.path }];
          this.formData.file_id = res.id;
        })
        .finally(() => {
          this.btnloading = false;
        });
      return false;
    },
    // 验证大小
    validateSize(file) {
      const size = this.uploadLimit * 1024 * 1024;
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = /(zip|rar)/;
      if (file.size > size || !imageRegex.test(suffix)) {
        this.$message.error(
          `请上传不大于 ${this.uploadLimit}MB 且格式为zip、rar 的文件`
        );
        return false;
      }
      return true;
    },
    hanleDeleteHomeworks() {
      const { id } = this.homework;
      this.loading = true;
      plusService
        .deleteHomeworks(id)
        .then(() => {
          this.showStudentPreview = false;
          this.showHeader = true;
          this.getData();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit() {
      this.$refs.homeworkForm.validate(valid => {
        if (valid) {
          const params = {
            source: "kongfu",
            source_id: this.sourceId,
            project_id: this.projectId,
            project_content_id: this.id,
            self_evaluation: this.formData.self_evaluation,
            self_summary: this.formData.self_summary,
            spend_time: this.formData.spend_time,
            file_id: this.formData.file_id,
            speak_to_teacher: this.formData.speak_to_teacher
          };
          this.loading = true;
          plusService
            .setHomeworks(params)
            .then(() => {
              this.showStudentPreview = true;
              this.showForm = false;
              this.getData();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleComment(data) {
      this.loading = true;
      const { id } = this.homework;
      plusService
        .homeworkComment(id, {
          student_evaluate_feedback: data.id,
          student_evaluate_comment: ""
        })
        .then(() => {
          this.homework.student_evaluate_feedback = data.id;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style type="text/css" lang="less" scoped>
.platform-homework {
  position: relative;

  .platform-homework-header {
    position: relative;
    text-align: left;
    color: #333;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 10px;

    .submit-again {
      float: right;
    }

    .platform-homework-header-text {
      font-size: 12px;
      color: #666;
      margin-left: 20px;
    }
  }

  .platform-homework-form {
    padding: 30px;
    border: 1px solid rgba(233, 237, 238, 1);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.05);

    .homework-form-title {
      margin-bottom: 30px;
      color: #919ea1;
      font-size: 14px;
      text-align: center;
      line-height: 24px;
    }
  }

  .platform-homework-preview {
    .homework-preview-teacher,
    .homework-preview-student {
      margin: 10px 0;
      padding: 20px 0 40px;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(233, 237, 238, 1);
    }

    .homework-preview-header {
      position: relative;
    }

    .homework-preview-body {
      padding: 30px 75px 0;
    }

    .homework-preview-title {
      position: relative;
      margin-bottom: 12px;
      height: 24px;
      font-size: 16px;
      color: #212b36;
      line-height: 24px;
      text-align: center;
    }

    .homework-preview-score {
      position: absolute;
      top: -5px;
      left: 0;
      width: 78px;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      font-size: 14px;
      color: #fff;
      background: linear-gradient(270deg, #ff6a6a 0%, #ff8875 100%);
      &:after,
      &:before {
        content: "";
        position: absolute;
        right: 0;
        border: 10px solid transparent;
        border-right-color: #fff;
        transform: scaleY(1.5);
      }

      &:before {
        top: -10px;
      }

      &:after {
        top: 20px;
      }
    }

    .homework-preview-revert {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 12px;
      color: #676d7e;
      transition: all 0.2s;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .homework-preview-header-info {
      display: flex;
      justify-content: space-between;
      line-height: 24px;
      font-size: 14px;
      color: #333;
      padding: 0 75px 12px;
      border-bottom: 2px solid #e9edee;

      .header-info-item {
        flex: none;
        text-align: center;
      }

      a {
        color: #35b558;
      }

      .download__icon {
        display: inline-block;
        margin-left: 4px;
      }
    }

    .home-preview-body-info {
      .body-info-item {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .body-info-label {
        line-height: 24px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #333;
      }
      .body-info-content {
        line-height: 24px;
        font-size: 14px;
        color: #666;
        white-space: pre-line;
      }
    }
  }

  .preview-slider-item {
    display: flex;
    margin-top: 32px;
    .slider-item-label {
      flex: none;
      width: 80px;
      line-height: 20px;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 20px;
    }
    .slider-item-content {
      flex: 1;
      position: relative;
    }

    .item-slider-bg {
      position: relative;
      height: 10px;
      margin-bottom: 1px;
      border-radius: 10px;
      overflow: hidden;
      background-image: linear-gradient(
        90deg,
        #5c33e2 0%,
        #33e2a7 33%,
        #ffe500 66%,
        #ff7258 100%
      );
      .item-slider-bg-mask {
        position: absolute;
        top: 0;
        right: 0;
        height: 10px;
        background-color: #f5f5f5;
      }
    }

    .item-slider-option-list {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #666;
    }

    .item-slider-tooltip {
      position: absolute;
      top: -34px;
      left: 0;
      width: 42px;
      height: 42px;
      font-size: 12px;
      line-height: 32px;
      color: #fff;
      text-align: center;
      background: url("~@/assets/images/edu/homework_score.png") no-repeat;
      background-size: 42px;
      transform: translate(-50%) scale(0.7);
    }
  }

  .platform-homework-comment {
    position: relative;
    padding: 25px;
    text-align: center;
    background: #eaf9f4;
    .platform-comment-title {
      margin-bottom: 15px;
      font-size: 18px;
      line-height: 24px;
      color: #333;
    }
    .platform-comment-desc {
      margin-bottom: 15px;
      font-size: 13px;
      line-height: 25px;
      white-space: pre-line;
    }

    .platform-comment-list {
      display: flex;
      justify-content: center;

      .platform-comment-item {
        margin: 0 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .platform-comment-icon {
          display: block;
          margin: 0 auto 10px;
          height: 35px;
          width: 35px;
          // max-width: 90px;
          background-color: #f1f1f1;
        }
        .platform-comment-text {
          font-size: 14px;
          color: #333;
          line-height: 18px;
          max-width: 90px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .platform-comment-btn {
          display: inline-block;
          vertical-align: top;
          height: 32px;
          line-height: 32px;
          padding: 0 16px;
          margin: 0 5px;
          font-size: 14px;
          background: #35b558;
          color: #fff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          transition: all 0.2s;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .platform-comment-select {
      .platform-comment-icon {
        display: inline-block;
        vertical-align: middle;
        height: 35px;
        width: 35px;
        margin-right: 10px;
        background-color: #f1f1f1;
      }
      .platform-comment-text {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #333;
        line-height: 18px;
      }
    }

    .platform-comment-editBtn {
      position: absolute;
      bottom: 20px;
      right: 25px;
      font-size: 13px;
      color: #000;
      text-decoration: underline;
      transition: all 0.2s;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
